import type { MotionProps } from 'framer-motion';
import {
  buildHiddenVariant,
  buildVisibleVariant,
} from '@/components/animations';

const visible = buildVisibleVariant({ transition: { duration: 0.75 } });

/*
 * Child Element
 */
const CHILD_ELEMENT_OFFSET_Y = -50;

export const childElementMotionProperties: MotionProps = {
  variants: {
    hidden: buildHiddenVariant({ y: CHILD_ELEMENT_OFFSET_Y }),
    visible,
  },
};

/*
 * Mobile Wrapper Element
 */
export const mobileWrapperElementMotionProperties: MotionProps = {
  initial: 'hidden',
  variants: {
    hidden: buildHiddenVariant({
      transition: { staggerChildren: 0.05, staggerDirection: -1 },
    }),
    visible: buildVisibleVariant({
      transition: { delayChildren: 0.2, staggerChildren: 0.07 },
    }),
  },
  whileInView: 'visible',
};

/*
 * Mobile Item
 */
export const mobileItemElementMotionProperties: MotionProps = {
  variants: {
    hidden: buildHiddenVariant({
      transition: { y: { stiffness: 1000 } },
      y: 50,
    }),
    visible: buildVisibleVariant({
      transition: { y: { stiffness: 1000, velocity: -100 } },
    }),
  },
  whileHover: { scale: 1.1 },
  whileTap: { scale: 0.95 },
};

/*
 * Mobile Button
 */
const MOBILE_BUTTON_OFFSET_X = 50;

export const mobileButtonMotionProperties: MotionProps = {
  variants: {
    hidden: buildHiddenVariant({ x: MOBILE_BUTTON_OFFSET_X }),
    visible,
  },
};
